var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Analytics")]),_c('span',[_c('h1',[_vm._v("Period: "+_vm._s(_vm.settings.period))]),_c('h1',[_vm._v("Contract: "+_vm._s(_vm.settings.contract))])])])}
var staticRenderFns = []

export { render, staticRenderFns }